import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_LT_UQ || "uq.lt.styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_LT_UQ || 24345,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_LT_UQ || 24346,
  firebaseApiKey:
    process.env.REACT_APP_FIREBASE_API_KEY_EU_UQ ||
    "AIzaSyDE056gop2EPT3-XkaMwgmebYyxvrAtm5w",
  firebaseProjectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID_EU_UQ || "fr-stg-ec-frontend",
  firebaseAppId:
    process.env.REACT_APP_FIREBASE_APP_ID_EU_UQ ||
    "1:160978693362:web:e3ce0b06e5d443cc47346b",
  firebaseMeasurementId:
    process.env.REACT_APP_ENV === "staging" ? "G-2SB8ZPM5X6" : "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: false,
  showDualPrice: true,
  languages: [LANGUAGE.EN],
  countryRegion: "Europe/Vilnius",
  timeZone: {
    [LANGUAGE.EN]: {
      defaultTimezone: "EET",
      offset: {
        EET: 2,
        EEST: 3,
        "GMT+2": 2,
        "GMT+3": 3
      }
    }
  },
  timeZoneParentCategory: {
    "GMT+2": "EET",
    "GMT+3": "EEST"
  },
  dateFormat: {
    [LANGUAGE.EN]: "<dd>/<mm>/<yyyy>"
  },
  requireDecimal: true
};

export default _countryEnv;
